import { addDoc, collection } from "firebase/firestore";
import { db } from "../../../firebase";
import HelperForMetaData from "../../../Helpers/HelperForMetaData";

const CreateCourse = async (e, uid, ClassID) => {
  try {
    const CoursesCollection = await collection(db, "Courses");

    const data = HelperForMetaData({
      ...e,
      ClassID: ClassID,
    });
    await addDoc(CoursesCollection, data);
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export default CreateCourse;
